import { useState, useEffect } from "react";
import FlexxLogoImg from "../FlexxLogoImg";

const Navigation = ({ onJoinClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  const handleJoinClick = () => {
    setIsMobileMenuOpen(false);
    onJoinClick();
  };

  return (
    <nav data-testid="navigation" className={`nav-container ${isScrolled ? 'nav-scrolled' : ''}`}>
      <div className="nav-inner">
        {/* Logo */}
        <a href="/" className="nav-logo" data-testid="nav-logo">
          <FlexxLogoImg alt="FLEXX Academy" />
        </a>

        {/* Desktop Navigation */}
        <div className="nav-links-desktop">
          <a 
            href="#why-exists" 
            onClick={(e) => { e.preventDefault(); handleNavClick('why-exists'); }} 
            className="nav-link"
            data-testid="nav-link-about"
          >
            About
          </a>
          <a 
            href="#learning-pillars" 
            onClick={(e) => { e.preventDefault(); handleNavClick('learning-pillars'); }} 
            className="nav-link"
            data-testid="nav-link-learning"
          >
            Learning
          </a>
          <a 
            href="#collaboration" 
            onClick={(e) => { e.preventDefault(); handleNavClick('collaboration'); }} 
            className="nav-link"
            data-testid="nav-link-collaboration"
          >
            Collaboration
          </a>
          <a 
            href="#community-experiences" 
            onClick={(e) => { e.preventDefault(); handleNavClick('community-experiences'); }} 
            className="nav-link"
            data-testid="nav-link-community"
          >
            Community
          </a>
          <a 
            href="https://courses.flexx-academy.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="nav-link"
            data-testid="nav-link-courses"
          >
            Courses
          </a>
          <a 
            href="#faq" 
            onClick={(e) => { e.preventDefault(); handleNavClick('faq'); }} 
            className="nav-link"
            data-testid="nav-link-faq"
          >
            FAQ
          </a>
          <button 
            className="nav-cta" 
            onClick={handleJoinClick}
            data-testid="nav-join-btn"
          >
            JOIN
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="nav-mobile-toggle" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`nav-mobile-menu ${isMobileMenuOpen ? 'open' : ''}`} data-testid="mobile-menu">
        <a 
          href="#why-exists" 
          onClick={(e) => { e.preventDefault(); handleNavClick('why-exists'); }} 
          className="nav-mobile-link"
        >
          About
        </a>
        <a 
          href="#learning-pillars" 
          onClick={(e) => { e.preventDefault(); handleNavClick('learning-pillars'); }} 
          className="nav-mobile-link"
        >
          Learning
        </a>
        <a 
          href="#collaboration" 
          onClick={(e) => { e.preventDefault(); handleNavClick('collaboration'); }} 
          className="nav-mobile-link"
        >
          Collaboration
        </a>
        <a 
          href="#community-experiences" 
          onClick={(e) => { e.preventDefault(); handleNavClick('community-experiences'); }} 
          className="nav-mobile-link"
        >
          Community
        </a>
        <a 
          href="https://courses.flexx-academy.com/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="nav-mobile-link"
          data-testid="nav-mobile-link-courses"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Courses
        </a>
        <a 
          href="#faq" 
          onClick={(e) => { e.preventDefault(); handleNavClick('faq'); }} 
          className="nav-mobile-link"
        >
          FAQ
        </a>
        <button 
          className="nav-mobile-cta" 
          onClick={handleJoinClick}
        >
          JOIN THE COMMUNITY
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
